import { render, staticRenderFns } from "./RegisterStep4.vue?vue&type=template&id=ad411850"
import script from "./RegisterStep4.vue?vue&type=script&lang=js"
export * from "./RegisterStep4.vue?vue&type=script&lang=js"
import style0 from "./RegisterStep4.vue?vue&type=style&index=0&id=ad411850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports